import pilotQR from '../pilotqr.png';

const PilotPage = () => {
  return (
    <div className="App">
      <section className="section" style={{ backgroundColor: 'var(--light)', minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
        <div className="container">
          <div className="section-title">
            <h2>Interested in participating in our pilot? Scan the QR code or visit our <a href="https://forms.gle/SyZMj82q6DiFtJb39">google form</a> </h2>
            <p>Scan the QR code to fill out our form.</p>
            <img src={pilotQR} alt="Pilot QR Code" style={{ width: '200px', marginTop: '20px' }} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default PilotPage;
